export default {
  setAutomativeOptionBoxFlag({ commit }, payload) {
    commit("automativeOptionBoxFlagActions", payload);
  },
  setBankingSectorOptionBoxFlag({ commit }, payload) {
    commit("BankingSectorOptionBoxFlagActions", payload);
  },
  setCreditCardSectorBoxFlag({ commit }, payload) {
    commit("CreditCardSectorOptionBoxFlagActions", payload);
  },
  setSectorDropdownDataAPI({ commit }, payload) {
    commit("SECTORDROPDOWNDATAAPI", payload);
  },
  setCategoryAction({ commit }, payload) {
    // console.log("action ", payload);
    commit("SECTORCATEGORYDROPDOWNDATAAPI", payload);
    // category sorted data
  },
  setSubCategoryAction({ commit }, payload) {
    // console.log("action sub ", payload);
    // subcategory sorted data
    commit("SECTORSUBCATEGORYDATAMUT", payload);
  },
  setSubSubCategoryAction({ commit }, payload) {
    // console.log("action subsub ", payload);
    // subsubcategory sorted data
    commit("SECTORSUBSUBCATEGORYDATAMUT", payload);
  },
  setCategoryFieldsCleaningAction({ commit }, payload) {
    // console.log("action ", payload);
    commit("CategoryFieldsCleaningMUT", payload);
  },
  setProductNameAction({ commit }, payload) {
    // console.log("action ", payload);
    commit("PRODUCTNAMEOPENMUT", payload);
  },
  setBankingCardAction({ commit }, payload) {
    // console.log("action ", payload);
    commit("BankingCardActionMut", payload);
  },
  setCreditComboBoxesAction({ commit }, payload) {
    // console.log("action ", payload);
    commit("CreditComboBoxesMut", payload);
  },
  setEnergyBoxesFlag({ commit }, payload) {
    // console.log("action ", payload);
    commit("EnergyBoxesFlagMut", payload);
  },
  setSectorIdsComm({ commit }, payload) {
    // console.log("action ", payload);
    commit("SectorIdsCommMut", payload);
  },
  setSectorAllIds({ commit }, payload) {
    // console.log("action ", payload);
    commit("SectorAllIdsMut", payload);
  },
  setSectorCommData({ commit }, payload) {
    // console.log("action ", payload);
    commit("SectorCommDataMut", payload);
  },
  setMortageSelectedAction({ commit }, payload) {
    // console.log("action ", payload);
    commit("MortageSelectedMut", payload);
  },
  setresponseMechanismAction({ commit }, payload) {
    // console.log("res ", payload);
    commit("responseMechanismMut", payload);
  },
  setresponseMechanismAPIAction({ commit }, payload) {
    // console.log("action ", payload);
    commit("responseMechanismAPIMut", payload);
  },
  setRangeSliderAction({ commit }, payload) {
    // console.log("action ", payload);
    commit("rangeSliderAPIMut", payload);
  },
  setInsuranceBoxFlagAction({ commit }, payload) {
    commit("InsuranceBoxFlagMut", payload);
  },
  setInvestmentBoxFlagAction({ commit }, payload) {
    commit("InvestmentBoxFlagMut", payload);
  },
  setTravelRetailBoxFlagAction({ commit }, payload) {
    // console.log(payload, "sss");
    commit("TravelRetailBoxFlagMut", payload);
  },
  setSectorIdsRiders({ commit }, payload) {
    commit("sectorIdsRidersDataMut", payload);
  },
  setSectorFaceAmtData({ commit }, payload) {
    commit("SectorFaceAmtDataMut", payload);
  },
  setIssueTypeData({ commit }, payload) {
    commit("SectorIssueTypeDataMut", payload);
  },
  setEDCEnergyData({ commit }, payload) {
    commit("SectorEDCEnergyDataMut", payload);
  },
  setDeliveryMethodId({ commit }, payload) {
    commit("DeliveryMethodId", payload);
  },
  setDeliveryTypeId({ commit }, payload) {
    commit("DeliveryTypeId", payload);
  },
  setPackageTypeId({ commit }, payload) {
    commit("PackageTypeId", payload);
  },
  setPresortedId({ commit }, payload) {
    commit("PresortedId", payload);
  },
  setPostageId({ commit }, payload) {
    commit("PostageId", payload);
  },
  setEnergySetPayload({ commit }, payload) {
    commit("EnergySetPayload", payload);
  },
  setSiDropDownPayload({ commit }, payload) {
    // console.log(payload, "sidAction");
    commit("SiDropDown", payload);
  },
  setcategoryPayloadAct({ commit }, payload) {
    commit("categoryPayloadMut", payload);
  },
  setunCheckcategoryPayloadAct({ commit }, payload) {
    commit("unCheckcategoryPayloadMut", payload);
  },
  setsubcategoryPayloadAct({ commit }, payload) {
    // console.log(payload, "payloadsubaction");
    commit("subcategoryPayloadMut", payload);
  },
  setunCheckSubcategoryPayloadAct({ commit }, payload) {
    commit("unCheckSubcategoryPayloadMut", payload);
  },
  setsubsubcategoryPayloadAct({ commit }, payload) {
    commit("subsubcategoryPayloadMut", payload);
  },
  setunCheckSubSubcategoryPayloadAct({ commit }, payload) {
    commit("unCheckSubSubcategoryPayloadMut", payload);
  },
  setcategorySelectedAct({ commit }, payload) {
    commit("categorySelectedMut", payload);
  },
  setsubcategorySelectedAct({ commit }, payload) {
    // console.log(payload, "subcat");
    commit("subcategorySelectedMut", payload);
  },
  setsubsubcategorySelectedAct({ commit }, payload) {
    commit("subSubcategorySelectedMut", payload);
  },
  setOfferOrigin({ commit }, payload) {
    commit("SectorIdOfferOrigin", payload);
  },
  setLoanAmount({ commit }, payload) {
    commit("LoanAmount", payload);
  },
  setAffinityCategories({ commit }, payload) {
    commit("AffinityCategories", payload);
  },
  setCheckboxPayload({ commit }, payload) {
    commit("CheckboxPayloadSet", payload);
  },
  setDropDownSetValues({ commit }, payload) {
    commit("DropDownSetValues", payload);
  },
  setTargetIDs({ commit }, payload) {
    commit("TargetIDs", payload);
  },
  setDefaultDropdown({ commit }, payload) {
    commit("DefaultDropdown", payload);
  },
  setTermLength({ commit }, payload) {
    commit("SetOrRemoveTermLength", payload);
  },
  setBankCreditAction({ commit }, payload) {
    commit("BankCreditAction", payload);
  },
  setAllCategory({ commit }, payload) {
    commit("AllCategorySetMut", payload);
  },
  setAllCategoryLocalAction({ commit }, payload) {
    commit("AllCategoryLocalMut", payload);
  },
  setAllSubCategoryLocalAction({ commit }, payload) {
    commit("AllSubCategoryLocalMut", payload);
  },
  setAllSubSubCategoryLocalAction({ commit }, payload) {
    commit("AllSubSubCategoryLocalMut", payload);
  },
  setSelectAllFlagAction({ commit }, payload) {
    commit("SelectAllFlagMut", payload);
  },
  setOrignalCommuncationCopied({ commit }, payload) {
    commit("OrignalCommuncationCopiedMut", payload);
  },
  setCommunicationTypeData({ commit }, payload) {
    commit("CommunicationTypeData", payload);
  },
  setselectedDataAction({ commit }, payload) {
    // console.log("cr", payload);
    commit("selectedDataMut", payload);
  },
  setLastSearchActivated({ commit }, payload) {
    // console.log("cr", payload);
    commit("LastSearchActivated", payload);
  },
  setcategoriesParents({ commit }, payload) {
    // console.log("cr", payload);
    commit("categoriesParents", payload);
  },
};
